import { render, staticRenderFns } from "./futureCity.vue?vue&type=template&id=72d6f76a&scoped=true"
import script from "./futureCity.vue?vue&type=script&lang=js"
export * from "./futureCity.vue?vue&type=script&lang=js"
import style0 from "./futureCity.vue?vue&type=style&index=0&id=72d6f76a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d6f76a",
  null
  
)

export default component.exports